import React from "react";
import "./user-management-status.scss";

const statusColors: { [key: string]: string } = {
  "ACTIVE": "active",
  "INACTIVE": "inactive",
  "PENDING": "pending",
  "Active": "active",
  "Inactive": "inactive",
};

const UserManagementStatus: React.FC<{ status: string }> = ({ status }) => {
  return (
    <span className={`status-badge ${statusColors[status]}`}>{status}</span>
  );
};

export default UserManagementStatus;
